import {
    PanelAggregate,
    PanelDisplayBy,
    PanelDisplayUnits,
    PanelPlotBy,
    PanelRateBy,
    PanelRateByType,
    PanelSiteScoring,
    PanelThresholdType,
    PanelTimePeriod,
    PanelOrderBy,
} from 'types/graphql-global-types';

const PanelConstants = {
    seriesRowData: [
        'SITE',
        'SITE_ISSUE',
        'SITE_PROTOCOL_DEVIATION',
        'SITE_VISIT',
        'SUBJECT',
        'SUBJECT_ADVERSE_EVENT',
        'SUBJECT_ASSESSMENT',
        'SUBJECT_CRF',
        'SUBJECT_ISSUE',
        'SUBJECT_LAB',
        'SUBJECT_PROTOCOL_DEVIATION',
        'SUBJECT_QUERY',
        'SUBJECT_VISIT',
    ],
    formats: {
        Text: 'TEXT',
        Date: 'DATE',
        PartialDate: 'PARTIAL_DATE',
        Int: 'INT',
        Float: 'FLOAT',
        Bool: 'BOOL',
    },
    modelParamsShow: {
        HideUpper: 'hide-upper',
        HideLower: 'hide-lower',
        All: 'all',
    },
    modelOptions: {
        NEGATIVE_BINOMIAL: 'NEGATIVE_BINOMIAL',
        NEGATIVEBINOMIAL: 'NEGATIVEBINOMIAL',
        FUNNEL: 'FUNNEL',
        FUNNEL_TREND: 'FUNNEL_TREND',
        FUNNELTREND: 'FUNNELTREND',
        TRI_OPERATIONAL: 'TRI_OPERATIONAL',
        TRIOPERATIONAL: 'TRIOPERATIONAL',
        TRI_OPERATIONAL_TREND: 'TRI_OPERATIONAL_TREND',
        TRIOPERATIONALTREND: 'TRIOPERATIONALTREND',
        RATE_GROUP: 'RATE_GROUP',
        RATEGROUP: 'RATEGROUP',
        RATE_GROUP_TREND: 'RATE_GROUP_TREND',
        RATEGROUPTREND: 'RATEGROUPTREND',
    },
    modelOptionsDropdown: {
        NEGATIVE_BINOMIAL: 'NEGATIVE_BINOMIAL',
        FUNNEL: 'FUNNEL',
        FUNNEL_TREND: 'FUNNEL_TREND',
        TRI_OPERATIONAL: 'TRI_OPERATIONAL',
        TRI_OPERATIONAL_TREND: 'TRI_OPERATIONAL_TREND',
        RATE_GROUP: 'RATE_GROUP',
        RATE_GROUP_TREND: 'RATE_GROUP_TREND',
    },
    graphTypes: {
        HEATMAP: 'HEATMAP',
        COLUMN: 'COLUMN',
        SCATTER_PLOT_LINE: 'SCATTER_PLOT_LINE',
        SCATTERPLOTLINE: 'SCATTERPLOTLINE',
        DONUT: 'DONUT',
        STACKED_COLUMN: 'STACKED_COLUMN',
        STACKEDCOLUMN: 'STACKEDCOLUMN',
    },
    seriesType: {
        SITE: 'SITE',
        SUBJECT: 'SUBJECT',
        EVENT: 'EVENT',
        SITE_CUMULATIVE: 'SITE_CUMULATIVE',
        SITECUMULATIVE: 'SITECUMULATIVE',
        SITE_AVERAGE: 'SITE_AVERAGE',
        SITEAVERAGE: 'SITEAVERAGE',
        SUBJECT_BY_VISIT: 'SUBJECT_BY_VISIT',
        SUBJECTBYVISIT: 'SUBJECTBYVISIT',
    },
    siteScoringData: [
        {
            id: PanelSiteScoring.STANDARD,
            text: '1. Standard Scoring',
        },
        {
            id: PanelSiteScoring.LOWER_GREEN,
            text: '2. Lower than study average set to green',
        },
        {
            id: PanelSiteScoring.HIGHER_GREEN,
            text: '3. Higher than study average set to green',
        },
        {
            id: PanelSiteScoring.LOWER_PURPLE,
            text: '4. Lower than study average set to purple',
        },
        {
            id: PanelSiteScoring.HIGHER_PURPLE,
            text: '5. Higher than study average set to purple',
        },
    ],
    unitMultiplications: [
        {
            id: '',
            text: 'Select a value',
        },
        {
            id: 1,
            text: '1',
        },
        {
            id: 10,
            text: '10',
        },
        {
            id: 100,
            text: '100',
        },
        {
            id: 1000,
            text: '1000',
        },
        {
            id: 10000,
            text: '10000',
        },
        {
            id: 100000,
            text: '100000',
        },
    ],
    panelThresholdType: {
        SAMPLE_MEDIAN_MEAN: 'SAMPLE_MEDIAN_MEAN',
        SAMPLEMEDIANMEAN: 'SAMPLEMEDIANMEAN',
        STUDY_MEDIAN_MEAN: 'STUDY_MEDIAN_MEAN',
        STUDYMEDIANMEAN: 'STUDYMEDIANMEAN',
    },
    lineThresholdType: {
        STUDYSPECIFIC: 'STUDYSPECIFIC',
        STUDYMEAN: 'STUDYMEAN',
        STUDYMEDIAN: 'STUDYMEDIAN',
        SAMPLEMEAN: 'SAMPLEMEAN',
        SAMPLEMEDIAN: 'SAMPLEMEDIAN',
    },
    displayUnits: [
        {
            id: '',
            text: 'Select a value',
        },
        {
            id: PanelDisplayUnits.PERCENT,
            text: '% by Calculation',
        },
        {
            id: PanelDisplayUnits.PERCENT_BY_POPULATION,
            text: '% by Total Population',
        },
        {
            id: PanelDisplayUnits.COUNT,
            text: 'Count',
        },
    ],
    displayBy: [
        {
            id: '',
            text: 'Select a value',
        },
        {
            id: PanelDisplayBy.SITE,
            text: 'Site',
        },
        {
            id: PanelDisplayBy.SUBJECT,
            text: 'Subject',
        },
    ],
    rateBy: [
        {
            id: '',
            text: 'Select a value',
        },
        {
            id: PanelRateBy.WEEKS,
            text: 'Weeks',
        },
        {
            id: PanelRateBy.MONTHS,
            text: 'Months',
        },
        {
            id: PanelRateBy.YEARS,
            text: 'Years',
        },
    ],
    rateByType: [
        {
            id: '',
            text: 'Select a value',
        },
        {
            id: PanelRateByType.TIME_PERIOD,
            text: 'Time Period',
        },
        {
            id: PanelRateByType.COUNT,
            text: 'Count',
        },
    ],
    plotBy: [
        {
            id: '',
            text: 'Select a value',
        },
        {
            id: PanelPlotBy.MONTHS,
            text: 'Months',
        },
        {
            id: PanelPlotBy.WEEKS,
            text: 'Weeks',
        },
    ],
    dataInclusionPeriods: [
        {
            id: '',
            text: 'Select a value',
        },
        {
            id: PanelTimePeriod.DAYS,
            text: 'Days',
        },
        {
            id: PanelTimePeriod.WEEKS,
            text: 'Weeks',
        },
        {
            id: PanelTimePeriod.MONTHS,
            text: 'Months',
        },
        {
            id: PanelTimePeriod.QUARTERS,
            text: 'Quarters',
        },
        {
            id: PanelTimePeriod.YEARS,
            text: 'Years',
        },
    ],
    studyComparison: [
        {
            id: '',
            text: 'Select a value',
        },
        {
            id: PanelAggregate.MEAN,
            text: 'Mean',
        },
        {
            id: PanelAggregate.MEDIAN,
            text: 'Median',
        },
    ],
    thresholdType: [
        {
            id: '',
            text: 'Select a value',
        },
        {
            id: 'SAMPLE_MEDIAN_MEAN',
            text: 'Sample Median/Mean',
        },
        {
            id: 'STUDY_MEDIAN_MEAN',
            text: 'Study Median/Mean',
        },
        {
            id: PanelThresholdType.STUDY_SPECIFIC,
            text: 'Study Specific',
        },
    ],
    categoryTypes: [
        {
            id: '',
            text: 'Select a value',
        },
        {
            id: 'NUMBER',
            text: 'Numeric Ranges',
        },
        {
            id: 'DATE',
            text: 'Date Ranges',
        },
    ],
    endDateUsage: [
        {
            id: '',
            text: 'Select a value',
        },
        {
            id: 'EARLIEST',
            text: 'Earliest',
        },
        {
            id: 'LATEST',
            text: 'Latest',
        },
    ],
    columnOrders: [
        {
            id: PanelOrderBy.VOLUME_DESCENDING,
            text: 'Volume - Descending',
        },
        {
            id: PanelOrderBy.VOLUME_ASCENDING,
            text: 'Volume - Ascending',
        },
        {
            id: PanelOrderBy.VOLUME_BELL_CURVE,
            text: 'Volume - Bell Curve',
        },
        {
            id: PanelOrderBy.LABEL_DESCENDING,
            text: 'Label - Descending',
        },
        {
            id: PanelOrderBy.LABEL_ASCENDING,
            text: 'Label - Ascending',
        },
        {
            id: PanelOrderBy.LABEL_VISIT_SEQUENCE_NUMBER,
            text: 'Label - Visit Sequence #',
        },
    ],
    heatmapOrders: [
        {
            id: PanelOrderBy.LABEL_DESCENDING,
            text: 'Descending',
        },
        {
            id: PanelOrderBy.LABEL_ASCENDING,
            text: 'Ascending',
        },
        {
            id: PanelOrderBy.LABEL_VISIT_SEQUENCE_NUMBER,
            text: 'Visit Sequence #',
        },
    ],
    pageNumber: {
        step1Content: 1,
        step2Setup: 2,
        step3Preview: 3,
        step4Overview: 4,
    },
    displayByForStacked: [
        {
            id: PanelDisplayBy.COUNTRY,
            text: 'Country',
        },
        {
            id: PanelDisplayBy.EVENT,
            text: 'Event',
        },
        {
            id: PanelDisplayBy.SITE,
            text: 'Site',
        },
        {
            id: PanelDisplayBy.SUBJECT,
            text: 'Subject',
        },
    ],
    panelInputFields: [
        'active',
        'dataSource',
        'decision',
        'description',
        'graph',
        'id',
        'configId',
        'includeInSiteScoring',
        'modelParams',
        'name',
        'organisationId',
        'panelType',
        'recordId',
        'scheduleId',
        'studyId',
        'studyOverviewExtraColumns',
        'weight',
        'yAxisColumnValue',
        'panelTheme',
    ],
};

export default PanelConstants;
